const educationOptions=[
    {
        id: 1,
        name: 'High School',
        value: 'high-school'
    },
    {
        id: 2,
        name: 'Diploma',
        value: 'diploma'
    },
    {
        id: 3,
        name: 'Bachelor',
        value: 'bachelor'
    },
    {
        id: 4,
        name: 'Master',
        value: 'master'
    },
    {
        id: 5,
        name: 'PhD',
        value: 'phd'
    },
    {
        id: 6,
        name: 'Other',
        value: 'other'
    }

]

export default educationOptions